import _toConsumableArray from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { GeneralFeedback, TaskCancelFeedback, TaskFeedbackType } from 'yo-services/yolabs/services/poplarfrontend/enums_pb';
import { createContext, useCallback, useContext, useState } from 'react';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import { useTranslation } from '@yoweb/next-i18next';
import { completeTask, getTask, handoffTask, updateTaskToDraft } from '@poplar/lib/api/tasks';
import { ApiResponseStatus } from '@poplar/lib/api/utils';
import { useToast } from '@yoweb/ui/hooks/useToast';
import { PAGE_TODO_DETAILS } from '@poplar/constants/routes';
import { AblyResponseTypes, TaskSectionTypes, TodoEditType } from '@poplar/types/enums';
import { useAblyEvents } from '@poplar/hooks/useAblyEvents';
import { QUERY_PROPOSAL_ID, QUERY_TASK_SECTION_ID } from '@poplar/constants/queryParams';
import { useEntitlement } from '@poplar/contexts/EntitlementProvider';
import { TASK_HAS_REPEATING_QUESTION_TAG_LABEL } from '@poplar/constants/tasks';
import { Slide } from '@poplar/components/tasks/CreateTodoFlyout';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var AsyncCreateTodoFlyout = dynamic(function () {
  return import('@poplar/components/AsyncCore').then(function (mod) {
    return mod.CreateTodoFlyout;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak('@poplar/components/AsyncCore')];
    }
  }
});
var AsyncDeleteTaskModal = dynamic(function () {
  return import('@poplar/components/AsyncCore').then(function (mod) {
    return mod.DeleteTaskModal;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak('@poplar/components/AsyncCore')];
    }
  }
});
export var initialTaskContextValue = {
  state: {
    submittedTasks: [],
    deletedTasks: []
  },
  actions: {
    handoffTask: function handoffTask() {
      return Promise.resolve();
    },
    openDeleteTaskModal: function openDeleteTaskModal() {},
    openTaskIntakeModal: function openTaskIntakeModal() {},
    openTaskIntakeModalForTemplateId: function openTaskIntakeModalForTemplateId() {},
    openTaskIntakeModalForCategoryId: function openTaskIntakeModalForCategoryId() {},
    openSubscriptionFlow: function openSubscriptionFlow() {},
    updateTaskToDraft: function updateTaskToDraft() {},
    putTaskOnHoldRequest: function putTaskOnHoldRequest() {},
    cancelTaskRequest: function cancelTaskRequest() {},
    updateTask: function updateTask() {}
  }
};
export var validateHandoffTaskLazy = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(task) {
    var _yield$Promise$all, _yield$Promise$all2, validateQuestion;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Promise.all([import('@poplar/components/Questions/intake-form/utils').then(function (mod) {
              return mod.validateQuestion;
            })]);

          case 2:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
            validateQuestion = _yield$Promise$all2[0];
            return _context.abrupt("return", validateHandoffTask(task, validateQuestion));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function validateHandoffTaskLazy(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var validateHandoffTask = function validateHandoffTask(task, validateQuestion) {
  return task.pathOfBranchingQuestionsList ? task.pathOfBranchingQuestionsList.every(function (order) {
    return validateQuestion(task.questionsList[order - 1]);
  }) && validateQuestion(task.questionsList[task.questionsList.length - 1]) : task.questionsList.every(validateQuestion);
};
export var TaskContext = /*#__PURE__*/createContext(initialTaskContextValue);
export var TaskProvider = function TaskProvider(_ref2) {
  var _useAblyEvents;

  var children = _ref2.children,
      onboardingTask = _ref2.onboardingTask;

  var _useToast = useToast(),
      showToastError = _useToast.showToastError,
      showToastAction = _useToast.showToastAction,
      showToastMessage = _useToast.showToastMessage;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var router = useRouter();

  var _useEntitlement = useEntitlement(),
      refreshEntitlement = _useEntitlement.actions.refreshEntitlement;

  var _useState = useState([]),
      submittedTasks = _useState[0],
      setSubmittedTasks = _useState[1];

  var _useState2 = useState([]),
      deletedTasks = _useState2[0],
      setDeletedTasks = _useState2[1]; // Delete task


  var _useState3 = useState(undefined),
      confirmDeleteTask = _useState3[0],
      setConfirmDeleteTask = _useState3[1];

  var _useState4 = useState(),
      onDeleteFn = _useState4[0],
      setOnDeleteFn = _useState4[1];

  var _useState5 = useState(),
      initialError = _useState5[0],
      setInitialError = _useState5[1]; // Create/update task


  var _useState6 = useState(onboardingTask),
      taskIntakeTask = _useState6[0],
      setTaskIntakeTask = _useState6[1];

  var _useState7 = useState(),
      taskIntakeTaskTitle = _useState7[0],
      setTaskIntakeTaskTitle = _useState7[1];

  var _useState8 = useState(),
      taskTemplateId = _useState8[0],
      setTaskTemplateId = _useState8[1];

  var _useState9 = useState(),
      categoryId = _useState9[0],
      setCategoryId = _useState9[1];

  var _useState10 = useState(),
      initialSlideType = _useState10[0],
      setInitialSlideType = _useState10[1];

  var _useState11 = useState(Boolean(onboardingTask)),
      isTaskCreateModalOpen = _useState11[0],
      setIsTaskCreateModalOpen = _useState11[1];

  var _useState12 = useState(Boolean(onboardingTask)),
      isSubscriptionFlow = _useState12[0],
      setIsSubscriptionFlow = _useState12[1];

  var _useState13 = useState(),
      todoEditType = _useState13[0],
      setTodoEditType = _useState13[1];

  var resetStates = useCallback(function () {
    setTaskIntakeTaskTitle(undefined);
    setTaskIntakeTask(undefined);
    setInitialSlideType(undefined);
    setTaskTemplateId(undefined);
    setCategoryId(undefined);
    setIsSubscriptionFlow(false);
    setTodoEditType(undefined);
  }, []);

  var handleHandoffTask = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(task, options) {
      var _ref4, onError, onSuccess, _ref4$skipValidation, skipValidation, _ref4$showToastOnSucc, showToastOnSuccess, _options$onError, handoff;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _ref4 = options || {}, onError = _ref4.onError, onSuccess = _ref4.onSuccess, _ref4$skipValidation = _ref4.skipValidation, skipValidation = _ref4$skipValidation === void 0 ? false : _ref4$skipValidation, _ref4$showToastOnSucc = _ref4.showToastOnSuccess, showToastOnSuccess = _ref4$showToastOnSucc === void 0 ? true : _ref4$showToastOnSucc;
              _context2.t0 = !skipValidation;

              if (!_context2.t0) {
                _context2.next = 6;
                break;
              }

              _context2.next = 5;
              return validateHandoffTaskLazy(task);

            case 5:
              _context2.t0 = !_context2.sent;

            case 6:
              if (!_context2.t0) {
                _context2.next = 9;
                break;
              }

              options === null || options === void 0 ? void 0 : (_options$onError = options.onError) === null || _options$onError === void 0 ? void 0 : _options$onError.call(options, {
                title: t('error-missing-required-fields-title', {
                  ns: 'common'
                }),
                message: t('error-missing-required-fields-body', {
                  ns: 'common'
                })
              });
              return _context2.abrupt("return");

            case 9:
              _context2.next = 11;
              return handoffTask(task.taskId);

            case 11:
              handoff = _context2.sent;

              if (!(handoff.status === ApiResponseStatus.ERROR || !handoff.data)) {
                _context2.next = 15;
                break;
              }

              onError === null || onError === void 0 ? void 0 : onError(new Error());
              return _context2.abrupt("return");

            case 15:
              onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(handoff.data);
              showToastOnSuccess && showToastMessage({
                message: t('task-handoff-success-title-v2')
              });

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleHandoffTask(_x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleUpdateTaskToDraft = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(taskId, options) {
      var _ref6, onError, onSuccess, _ref6$showToastOnErro, showToastOnError, _ref6$showToastOnSucc, showToastOnSuccess, updated;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _ref6 = options || {}, onError = _ref6.onError, onSuccess = _ref6.onSuccess, _ref6$showToastOnErro = _ref6.showToastOnError, showToastOnError = _ref6$showToastOnErro === void 0 ? true : _ref6$showToastOnErro, _ref6$showToastOnSucc = _ref6.showToastOnSuccess, showToastOnSuccess = _ref6$showToastOnSucc === void 0 ? true : _ref6$showToastOnSucc;
              _context3.next = 3;
              return updateTaskToDraft(taskId);

            case 3:
              updated = _context3.sent;

              if (!(updated.status === ApiResponseStatus.ERROR || !updated.data)) {
                _context3.next = 8;
                break;
              }

              onError === null || onError === void 0 ? void 0 : onError();
              showToastOnError && showToastError();
              return _context3.abrupt("return");

            case 8:
              onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(updated.data);
              showToastOnSuccess && showToastMessage({
                message: t('task-update-to-draft-success-title')
              });

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleUpdateTaskToDraft(_x4, _x5) {
      return _ref5.apply(this, arguments);
    };
  }();

  var handleCancelRequest = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(task, cancelReason) {
      var comment,
          options,
          _ref8,
          onError,
          onSuccess,
          _ref8$showToastOnErro,
          showToastOnError,
          _ref8$showToastOnSucc,
          showToastOnSuccess,
          payload,
          updated,
          _args4 = arguments;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              comment = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : '';
              options = _args4.length > 3 ? _args4[3] : undefined;
              _ref8 = options || {}, onError = _ref8.onError, onSuccess = _ref8.onSuccess, _ref8$showToastOnErro = _ref8.showToastOnError, showToastOnError = _ref8$showToastOnErro === void 0 ? true : _ref8$showToastOnErro, _ref8$showToastOnSucc = _ref8.showToastOnSuccess, showToastOnSuccess = _ref8$showToastOnSucc === void 0 ? true : _ref8$showToastOnSucc;
              payload = {
                taskFeedback: {
                  generalFeedback: GeneralFeedback.GENERAL_FEEDBACK_UNSPECIFIED,
                  detailFeedbackText: comment,
                  taskCancelFeedback: cancelReason,
                  taskFeedbackType: TaskFeedbackType.TASK_FEEDBACK_TYPE_CANCEL,
                  feedbackSkipped: false,
                  proposalFeedbackSkipped: false,
                  proposalFeedbackList: []
                }
              };
              _context4.next = 6;
              return completeTask(task.taskId, payload);

            case 6:
              updated = _context4.sent;

              if (!(updated.status === ApiResponseStatus.ERROR)) {
                _context4.next = 11;
                break;
              }

              onError === null || onError === void 0 ? void 0 : onError();
              showToastOnError && showToastError();
              return _context4.abrupt("return");

            case 11:
              onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
              showToastOnSuccess && showToastMessage({
                message: t('task-cancel-request-success-title')
              });

            case 13:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleCancelRequest(_x6, _x7) {
      return _ref7.apply(this, arguments);
    };
  }();

  var handlePutOnHoldRequest = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(task) {
      var comment,
          options,
          _ref10,
          onError,
          onSuccess,
          _ref10$showToastOnErr,
          showToastOnError,
          _ref10$showToastOnSuc,
          showToastOnSuccess,
          payload,
          updated,
          _args5 = arguments;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              comment = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : '';
              options = _args5.length > 2 ? _args5[2] : undefined;
              _ref10 = options || {}, onError = _ref10.onError, onSuccess = _ref10.onSuccess, _ref10$showToastOnErr = _ref10.showToastOnError, showToastOnError = _ref10$showToastOnErr === void 0 ? true : _ref10$showToastOnErr, _ref10$showToastOnSuc = _ref10.showToastOnSuccess, showToastOnSuccess = _ref10$showToastOnSuc === void 0 ? true : _ref10$showToastOnSuc;
              payload = {
                taskFeedback: {
                  generalFeedback: GeneralFeedback.GENERAL_FEEDBACK_UNSPECIFIED,
                  detailFeedbackText: comment,
                  taskCancelFeedback: TaskCancelFeedback.TASK_CANCEL_FEEDBACK_UNSPECIFIED,
                  taskFeedbackType: TaskFeedbackType.TASK_FEEDBACK_TYPE_ON_HOLD,
                  feedbackSkipped: false,
                  proposalFeedbackList: [],
                  proposalFeedbackSkipped: false
                }
              };
              _context5.next = 6;
              return completeTask(task.taskId, payload);

            case 6:
              updated = _context5.sent;

              if (!(updated.status === ApiResponseStatus.ERROR)) {
                _context5.next = 11;
                break;
              }

              onError === null || onError === void 0 ? void 0 : onError();
              showToastOnError && showToastError();
              return _context5.abrupt("return");

            case 11:
              onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
              showToastOnSuccess && showToastMessage({
                message: t('task-put-on-hold-success-title')
              });

            case 13:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function handlePutOnHoldRequest(_x8) {
      return _ref9.apply(this, arguments);
    };
  }();

  var handleShowActionToast = function handleShowActionToast(_ref11) {
    var message = _ref11.message,
        ctaText = _ref11.ctaText,
        url = _ref11.url,
        id = _ref11.id;
    return showToastAction({
      message: message,
      onClick: function onClick() {
        return router.push(url);
      },
      ctaText: ctaText,
      id: id,
      unique: !!id
    });
  }; // Ably event handlers


  useAblyEvents((_useAblyEvents = {}, _defineProperty(_useAblyEvents, AblyResponseTypes.NOTIFICATION_TYPE_TASK_PROPOSAL_READY_TO_REVIEW, function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(data) {
      var _task$data, _taskId, _task;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!(data.type === AblyResponseTypes.NOTIFICATION_TYPE_TASK_PROPOSAL_READY_TO_REVIEW)) {
                _context6.next = 6;
                break;
              }

              _taskId = data.payload.rootTaskId || data.payload.taskId;
              _context6.next = 4;
              return getTask(_taskId);

            case 4:
              _task = _context6.sent;
              handleShowActionToast({
                message: t('toasts.options-ready', {
                  todoName: (_task$data = _task.data) === null || _task$data === void 0 ? void 0 : _task$data.task.name
                }),
                ctaText: t('toasts.view-options'),
                url: "".concat(PAGE_TODO_DETAILS(_taskId), "?").concat(QUERY_TASK_SECTION_ID, "=").concat(TaskSectionTypes.option, "&").concat(QUERY_PROPOSAL_ID, "=").concat(data.payload.proposalId)
              });

            case 6:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x9) {
      return _ref12.apply(this, arguments);
    };
  }()), _defineProperty(_useAblyEvents, AblyResponseTypes.NOTIFICATION_TYPE_CHAT_MESSAGE_ADDED, function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(data) {
      var _task2$data, _taskId2, _task2;

      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (!(data.type === AblyResponseTypes.NOTIFICATION_TYPE_CHAT_MESSAGE_ADDED && data.payload.rootTaskId // If there is a rootTaskId, it's a discussion message
              )) {
                _context7.next = 6;
                break;
              }

              _taskId2 = data.payload.rootTaskId;
              _context7.next = 4;
              return getTask(_taskId2);

            case 4:
              _task2 = _context7.sent;
              handleShowActionToast({
                message: t('toasts.new-message', {
                  todoName: (_task2$data = _task2.data) === null || _task2$data === void 0 ? void 0 : _task2$data.task.name
                }),
                ctaText: t('toasts.view-message'),
                url: "".concat(PAGE_TODO_DETAILS(data.payload.rootTaskId), "?").concat(QUERY_TASK_SECTION_ID, "=").concat(TaskSectionTypes.messages)
              });

            case 6:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x10) {
      return _ref13.apply(this, arguments);
    };
  }()), _defineProperty(_useAblyEvents, AblyResponseTypes.NOTIFICATION_TYPE_TASK_CREATED_BY_REP, function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(data) {
      var _task3$data, _task3$data$task$repN, _taskId3, _task3;

      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              if (!(data.type === AblyResponseTypes.NOTIFICATION_TYPE_TASK_CREATED_BY_REP)) {
                _context8.next = 6;
                break;
              }

              _taskId3 = data.payload.rootTaskId || data.payload.taskId;
              _context8.next = 4;
              return getTask(_taskId3);

            case 4:
              _task3 = _context8.sent;
              handleShowActionToast({
                message: t('new-task-created-by-rep', {
                  name: (_task3$data = _task3.data) === null || _task3$data === void 0 ? void 0 : (_task3$data$task$repN = _task3$data.task.repName) === null || _task3$data$task$repN === void 0 ? void 0 : _task3$data$task$repN.givenName
                }),
                ctaText: t('toasts.view-todo'),
                url: PAGE_TODO_DETAILS(_taskId3)
              });

            case 6:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function (_x11) {
      return _ref14.apply(this, arguments);
    };
  }()), _defineProperty(_useAblyEvents, AblyResponseTypes.NOTIFICATION_TYPE_TASK_AWAITING_FEEDBACK, function (data) {
    if (data.type === AblyResponseTypes.NOTIFICATION_TYPE_TASK_AWAITING_FEEDBACK) {
      var _taskId4 = data.payload.rootTaskId || data.payload.taskId;

      handleShowActionToast({
        message: t('ready-for-feedback'),
        ctaText: t('toasts.view-todo'),
        url: PAGE_TODO_DETAILS(_taskId4)
      });
    }
  }), _useAblyEvents), 'rep');
  useAblyEvents(_defineProperty({}, AblyResponseTypes.NOTIFICATION_TYPE_ENTITLEMENT_CHANGED, function (data) {
    if (data.type === AblyResponseTypes.NOTIFICATION_TYPE_ENTITLEMENT_CHANGED) {
      void refreshEntitlement();
    }
  }), 'all');
  return /*#__PURE__*/_jsxs(TaskContext.Provider, {
    value: {
      state: {
        submittedTasks: submittedTasks,
        deletedTasks: deletedTasks
      },
      actions: {
        openDeleteTaskModal: function openDeleteTaskModal(task, onDeleteHandler) {
          setConfirmDeleteTask(task);
          setOnDeleteFn(function () {
            return function () {
              onDeleteHandler === null || onDeleteHandler === void 0 ? void 0 : onDeleteHandler();
              setDeletedTasks(function (prevTasks) {
                return [task].concat(_toConsumableArray(prevTasks));
              });
            };
          });
        },
        openTaskIntakeModal: function openTaskIntakeModal(task, taskError, options) {
          // making the task recurring should have the same behavior as editing just the
          // recurring question except we also have to automatically answer the initial
          // "Would you like to make this to-do recurring?" question as "Yes" for the user
          resetStates();

          if ((options === null || options === void 0 ? void 0 : options.editType) === TodoEditType.TODO_MAKE_RECURRING && task) {
            setTodoEditType(TodoEditType.TODO_EDIT_RECURRING_QUESTION);
            setTaskIntakeTask(_objectSpread(_objectSpread({}, task), {}, {
              questionsList: task.questionsList.map(function (question) {
                // find the "Would you like to make this to-do recurring?" question which has a special label
                if (question.tagsList.some(function (tag) {
                  return tag.label === TASK_HAS_REPEATING_QUESTION_TAG_LABEL;
                })) {
                  return _objectSpread(_objectSpread({}, question), {}, {
                    // make sure the question is answered 'yes'
                    answerOptionsList: question.answerOptionsList.map(function (answerOption) {
                      if (!answerOption.singleChoiceAnswer) {
                        return answerOption;
                      }

                      return _objectSpread(_objectSpread({}, answerOption), {}, {
                        singleChoiceAnswer: _objectSpread(_objectSpread({}, answerOption.singleChoiceAnswer), {}, {
                          answeredValue: answerOption.singleChoiceAnswer.choicesList.find(function (choice) {
                            var _choice$localizedText;

                            return ((_choice$localizedText = choice.localizedTextValue) === null || _choice$localizedText === void 0 ? void 0 : _choice$localizedText.key) === 'yes';
                          })
                        })
                      });
                    })
                  });
                }

                return question;
              })
            }));
          } else {
            setTodoEditType(options === null || options === void 0 ? void 0 : options.editType);
            setTaskIntakeTask(task);
          }

          setInitialError(taskError);
          setIsTaskCreateModalOpen(true);
        },
        openTaskIntakeModalForTemplateId: function openTaskIntakeModalForTemplateId(templateId) {
          var skipPdp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
          resetStates();
          setTaskTemplateId(templateId);
          setIsTaskCreateModalOpen(true);
          setInitialSlideType(!skipPdp ? Slide.PRODUCT_DESCRIPTION : undefined);
        },
        openTaskIntakeModalForCategoryId: function openTaskIntakeModalForCategoryId(newCategoryId) {
          resetStates();
          setCategoryId(newCategoryId);
          setIsTaskCreateModalOpen(true);
        },
        openSubscriptionFlow: function openSubscriptionFlow(taskTitle) {
          resetStates();
          setTaskIntakeTaskTitle(taskTitle);
          setIsSubscriptionFlow(true);
          setIsTaskCreateModalOpen(true);
        },
        handoffTask: handleHandoffTask,
        updateTaskToDraft: handleUpdateTaskToDraft,
        putTaskOnHoldRequest: handlePutOnHoldRequest,
        cancelTaskRequest: handleCancelRequest
      }
    },
    children: [children, /*#__PURE__*/_jsx(AsyncCreateTodoFlyout, {
      initialTask: taskIntakeTask,
      initialError: initialError,
      initialTaskTitle: taskIntakeTaskTitle,
      initialTaskTemplateId: taskTemplateId,
      initialCategoryId: categoryId,
      initialSlide: isSubscriptionFlow ? Slide.TEMPLATED_TODO : initialSlideType,
      isOpen: isTaskCreateModalOpen,
      isSubscriptionFlow: isSubscriptionFlow,
      onClose: function onClose() {
        return setIsTaskCreateModalOpen(false);
      },
      onSubmitted: function onSubmitted(task) {
        return setSubmittedTasks(function (prevTasks) {
          return [task].concat(_toConsumableArray(prevTasks));
        });
      },
      todoEditType: todoEditType
    }), /*#__PURE__*/_jsx(AsyncDeleteTaskModal, {
      task: confirmDeleteTask,
      isOpen: Boolean(confirmDeleteTask),
      onClose: function onClose() {
        setConfirmDeleteTask(undefined);
        setOnDeleteFn(undefined);
      },
      onTaskDeleted: onDeleteFn
    })]
  });
};
export var useTasks = function useTasks() {
  var context = useContext(TaskContext);

  if (context === undefined) {
    throw new Error('useTasks must be used within a TaskProvider');
  }

  return context;
};